import React from 'react'

import { RelationListContainer } from '@/components/containers/relation-list/RelationListContainer'
import { RelationListView } from '@/components/views/relation-list/RelationListView'

const RelationListPage: React.FC = () => <RelationListContainer View={(props) => <RelationListView {...props} />} />

export default RelationListPage
